import { motion } from "framer-motion";
import { ROLE_DATA } from "../../data/roles.js";
import { PlayerStatusBadges } from "./PlayerStatusBadges.jsx";

export function PlayerSelectCard({ player, selected, onSelect, disabled = false }) {
  const role = ROLE_DATA[player.baseRoleId];
  return (
    <div className={`w-full flex items-center gap-3 rounded-2xl p-3 border transition-all
      ${selected ? "border-amber-500 bg-amber-900/40 shadow-lg shadow-amber-900/40"
                 : "border-amber-900/30 bg-stone-950/40"}
      ${disabled ? "opacity-40" : ""}`}>
      <motion.button
        whileTap={disabled ? {} : { scale: 0.97 }}
        onClick={disabled ? undefined : () => onSelect(player.id)}
        className="flex-1 flex items-center gap-3 text-left">
        <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg shrink-0
          bg-gradient-to-br ${role?.gradient || "from-stone-800 to-stone-900"} border ${role?.border || "border-stone-700"}`}>
          {role?.emoji || "?"}
        </div>
        <div className="flex-1">
          <p className="text-amber-100 text-sm font-semibold">{player.name}</p>
          <PlayerStatusBadges player={player} />
        </div>
        {selected && <span className="text-amber-400 text-lg shrink-0">✓</span>}
      </motion.button>
    </div>
  );
}
